import React, {useMemo} from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';

import DataLayoutContext from './DataLayoutContext';
import DataLayoutSection from './DataLayoutSection';
import {DataLayout as DataLayoutType} from './DataLayoutTypes';

interface DataLayoutProps {
  actionOrigin: ActionOrigin;
  clientId: string;
  layout: DataLayoutType;
}

/**
 * Component for rendering data layouts.
 *
 * Data layouts are composed of sections, which are further composed of blocks. Blocks represent
 * a single piece of UI, and layouts define how to arrange those pieces of UI, and in the future
 * what types of interactions are possible across blocks.
 *
 * See DataLayoutTypes.ts for further details on the different types of sections and blocks.
 */
export default function DataLayout({actionOrigin, clientId, layout}: DataLayoutProps): JSX.Element {
  const contextValue = useMemo(() => ({actionOrigin, clientId}), [actionOrigin, clientId]);

  return (
    <DataLayoutContext.Provider value={contextValue}>
      {layout.sections.map((section, index) => (
        <DataLayoutSection section={section} key={index} />
      ))}
    </DataLayoutContext.Provider>
  );
}
